const PurchaseType = {
  SET_PURCHASE_REQUESTS_TODOLIST: 'SET_PURCHASE_REQUESTS_TODOLIST',
  SET_PURCHASE_TODO_LIST_COUNT: 'SET_PURCHASE_TODO_LIST_COUNT',
  SET_SELECTED_IDS_ARRAY: 'SET_SELECTED_IDS_ARRAY',
  SET_FILTER_SORT_DATA: 'PURCHASE_TODO_SET_FILTER_SORT_DATA',
  GET_MAIN_SAMPLES: 'GET_MAIN_SAMPLES',
  CATEGORY: 'CATEGORY',
  GET_OTHER_SAMPLES: 'GET_OTHER_SAMPLES',
  SET_TODO_LIST_COUNT: 'SET_TODO_LIST_COUNT',
  SET_CREATED_BY_USER: 'SET_CREATED_BY_USER',
};

export default PurchaseType;
